import React, { memo } from "react";
import styles from "./PrivacyPolicyContainer.module.scss";

import { PageWrapper, RecomendedQuests } from "components";

const TermsOfUseContainer = (props: any) => {
  return (
    <>
      <PageWrapper>
        {/* <div className={'flex flex-col items-center sm:flex-shrink-1 pb-4 md:p-2 sm:p-2 min-h-screen'}> */}
        <div
          className={
            "flex flex-wrap flex-col justify-center text-textAr text-left text-base w-full mt-12 sm:px-4 mb-8 sm:mt-5"
          }
        >
          <div className="text-xl text-center sm:text-left font-bold text-pink">
            Пользовательское соглашение
          </div>
          <br />
          Настоящее Пользовательское соглашение является договором между
          Администрацией и Пользователем, в котором определены условия
          пользования Сайтом, а также взаимные права и обязанности сторон.
          <br />
          <br />
          В соответствии с п. 1 ст. 398 Гражданского кодекса Республики Беларусь
          настоящее Пользовательское соглашение является договором
          присоединения.
          <br />
          <br />
          В соответствии с п. 2 ст. 407 Гражданского кодекса Республики Беларусь
          настоящее Пользовательское соглашение является публичной офертой.
          Пользовательское соглашение считается заключенным с момента получения
          Администрацией согласия Пользователя с условиями настоящего
          Пользовательского соглашения (акцепт оферты). Акцепт оферты
          производится путем осуществления Пользователем действий по регистрации
          Учетной записи. Пользовательское соглашение определяет условия
          использования Сайта, а также взаимные права и обязанности сторон.
          <br />
          <br />
          <span className="text-pink text-left">1. Общие положения</span>
          1.1. Сайт Questminsk, размещенный по адресу www.questminsk.by (далее —
          Сайт) — коммерческий ресурс Общества с ограниченной ответственностью
          «ОЛД МАУС», на котором размещаются статьи, фото- и видеоинформация,
          рекламная и другая информация от имени Администрации, а также
          предоставляется гражданам возможность целевого общения путем
          размещения в открытом доступе разнообразных сообщений для ознакомления
          с ними других посетителей.
          <br />
          <br />
          1.2. Термины и определения, применяемые в настоящих Пользовательском
          соглашении, имеют следующее значение:
          <br />
          <br />
          1.2.1. Пользователь — пользователь сети Интернет, изъявивший желание
          воспользоваться услугами Сайта, заключивший с Владельцем
          Интернет-ресурса (Администрацией) Пользовательское соглашение.
          <br />
          <br />
          1.2.2. Администрация — Общество с ограниченной ответственностью «ОЛД
          МАУС».
          <br />
          <br />
          1.2.3. Модератор — уполномоченное Администрацией лицо, занимающееся
          Модерацией.
          <br />
          <br />
          1.2.4. Модерация — действия Модератора, направленные на соблюдение
          пользователями Пользовательского соглашения.
          <br />
          <br />
          1.2.5. Информация — любые данные, тексты, графические изображения,
          фотоизображения, программное обеспечение, базы данных или данные из
          баз данных в любом объеме, аудио- и видеоинформация.
          <br />
          <br />
          1.2.6. Идентификация — совокупность мероприятий по установлению
          сведений о Пользователе.
          <br />
          <br />
          1.3. Согласие с настоящим Пользовательским соглашением может
          выражаться в том, что:
          <br />
          <br />
          1.3.1. Вы размещаете комментарии (отзывы) на Сайте.
          <br />
          <br />
          1.3.2. Вы посещаете Сайт. В этом случае Вы понимаете и соглашаетесь с
          тем, что Администрация будет расценивать факт пользования Вами Сайтом
          как согласие с Пользовательским соглашением с соответствующего момента
          времени.
          <br />
          <br />
          1.3.3. Незнание Пользовательского соглашения не только не освобождает
          вас от ответственности за их нарушение, но и само по себе является
          нарушением и отягчающим вину обстоятельством.
          <br />
          <br />
          1.4. Осуществлять просмотр Сайта и бронировать услуги, вправе любые
          посетители сети Интернет. Внутренними услугами (функционалом) Сайта
          вправе пользоваться только Зарегистрированные Пользователи.
          <br />
          <br />
          1.5. Идентификация Пользователя.
          <br />
          <br />
          1.5.1. Пользование Услугами Сайта осуществляется Пользователем после
          его Идентификации, которая производится при регистрации Учетной
          записи.
          <br />
          <br />
          1.5.2. Для оставления комментария(отзыва) на сайте Пользователь
          указывает свой адрес электронной почты:
          <br />
          <br />
          <br />
          <span className="text-pink text-left">2. Права и обязанности:</span>
          2.1. Права и обязанности Пользователя:
          <br />
          <br />
          2.1.1. Пользователь имеет право после ввода своей электронной почты
          размещать на Сайте комментарии (отзывы), а также пользоваться любыми
          иными сервисами Сайта. Пользователь имеет право на свободное
          высказывание собственного мнения по любой теме при условии соблюдения
          ограничений, установленных действующим законодательством Республики
          Беларусь, настоящим Пользовательским соглашением, прав третьих лиц.
          <br />
          <br />
          2.1.2. Пользователь обязуется соблюдать настоящее Пользовательское
          соглашение.
          <br />
          <br />
          2.1.3. В случае несогласия с Пользовательским соглашением Пользователь
          обязуется отказаться от дальнейшего использования Сайта.
          <br />
          <br />
          2.1.4. Пользователь обязуется предоставить полную, точную и
          достоверную информацию при осуществлении процедуры размещения
          комментария(отзывы)
          <br />
          <br />
          2.1.5. Пользователь обязуется не предпринимать действий, направленных
          на подрыв сетевой безопасности либо нарушение работы Сайта,
          программно-технических средств Администрации.
          <br />
          <br />
          2.1.6. Пользователь при размещении комментария, обязан соблюдать
          законодательство Республики Беларусь, действовать добросовестно,
          разумно и осмотрительно. Пользователь обязан учитывать тот факт, что в
          силу возможности из любой точки мира просматривать Сайт Пользователь
          своими сообщениями, темами, ником, подписью может нарушить
          законодательство какого-либо государства и может быть признан в связи
          с этим ответственным по законодательству такого государства (например,
          отрицание холокоста признается преступлением по законодательству
          некоторых государств).
          <br />
          2.1.7. Размещая на Сайте сообщения, создавая темы, используя ник,
          подпись, Пользователь тем самым подтверждает, что имеет на это все
          необходимые права, не нарушает этим права третьих лиц, а также
          какие-либо законы и иные акты обязательного характера.
          <br />
          <br />
          2.1.8. Пользователь не имеет права копировать (воспроизводить),
          перерабатывать, распространять, публиковать, скачивать, передавать,
          отчуждать или иным способом использовать целиком или по частям
          Информацию на Сайте, размещенную другим пользователем либо
          Администрацией, без предварительного разрешения такого другого
          пользователя (правообладателя, не являющегося пользователем) либо
          Администрации. Для того чтобы использовать (копировать) такую
          информацию, Пользователю необходимо связаться с таким пользователем,
          выяснить, кто является правообладателем в отношении указанной выше
          Информации, и получить разрешение на использование такой Информации.
          <br />
          <br />
          2.1.9. Пользователь обязуется не использовать Сайт для незаконных
          целей.
          <br />
          <br />
          2.1.10. Пользователь обязуется не использовать Сайт, в частности, для:
          <br />
          <ul>
            <li>- нарушения прав на интеллектуальную собственность;</li>
            <li>
              - оскорблений (диффамации), клеветы, умаления чести, достоинства,
              деловой репутации физических лиц, умаления деловой репутации
              организаций и т. п.;
            </li>
            <li>- размещения порнографических материалов;</li>
            <li>- разжигания межнациональной розни;</li>
            <li>
              - размещения призывов изменить власть неконституционным путем;
            </li>
            <li>
              - размещения информации о том, как изготавливать взрывчатые
              вещества, организовывать террористические акты;
            </li>
            <li>- размещения информации о способах совершения самоубийств;</li>
            <li>
              - размещения государственных секретов и коммерческих секретов
              (know-how и т. п.);
            </li>
            <li>
              - размещения информации о лицах, не достигших совершеннолетия без
              согласия их опекунов или родителей;
            </li>
            <li>
              - размещения иной любой информации, которая очевидно или случайно
              способна причинить вред любым лицам, в том числе рассылки не
              запрошенных писем, размещения множества одинаковых или не несущих
              смысловой нагрузки сообщений;
            </li>
            <li>
              - публикации персональных данных третьих лиц (в частности,
              телефонных номеров, адреса проживания) без их согласия;
            </li>
            <li>
              - продажи или информирования о наркотических или психотропных
              средствах и их прекурсорах;
            </li>
            <li>
              - размещения сообщений и (или) материалов, содержащих информацию,
              распространение которой запрещено законодательством Республики
              Беларусь.
            </li>
          </ul>
          <br />
          <br />
          2.1.11. Пользователь также обязуется:
          <br />
          <ul>
            <li>
              - не изменять каким-либо образом программное обеспечение Сайта или
              какую-либо его часть;
            </li>
            <li>
              - не получать доступ к Сайту с правами, которые позволяют
              контролировать Сайт или любую его часть;
            </li>
            <li>
              - не подвергать Сайт воздействию вредоносных программ, хакерским
              атакам и т. п.
            </li>
          </ul>
          <br />
          <br />
          2.1.13. Пользователь имеет право в любой момент расторгнуть в
          одностороннем порядке настоящее Пользовательское соглашение.
          <br />
          <br />
          2.2. Права и обязанности Администрации:
          <br />
          <br />
          2.2.1. Администрация вправе в течение срока действия Пользовательского
          соглашения, а также в течение 1 года с даты его расторжения хранить,
          обрабатывать и представлять в соответствии с действующим
          законодательством данные, указанные Пользователем в регистрационной
          форме, а также сведения о размещении и (или) изменении Пользователем
          на Сайте информационных сообщений и (или) материалов, дате и времени
          их размещения и (или) изменения; сведения о сетевом (IP) адресе
          устройства Пользователя, присвоенном при регистрации Пользователя на
          Сайте, внесении изменений в регистрационные данные Пользователя.
          <br />
          <br />
          2.2.2. Администрация вправе в любой момент расторгнуть в одностороннем
          порядке настоящее Пользовательское соглашение с Пользователем.
          <br />
          <br />
          2.2.3. Администрация при нарушении Пользователем настоящего
          Пользовательского соглашения (в том числе если посчитает, что
          информация, предоставленная Пользователем в регистрационной форме, не
          соответствует действительности) имеет право приостановить или
          прекратить права данного Пользователя по использованию всех или
          некоторых возможностей Сайта.
          <br />
          <br />
          2.2.4. Администрация имеет право расширять функциональность Сайта,
          изменять объем, характер и способы пользования Сайтом, в том числе
          устанавливать ограничения технического характера: количество личных
          сообщений, объем и число прикрепляемых файлов, наличие и количество
          строк присоединяемой рекламной информации, максимальное число
          адресатов сообщения, максимальная длина сообщения на Сайте,
          периодичность сбора информации поисковой машиной, перечень
          поддерживаемых протоколов, номера используемых портов и другие
          технические характеристики и параметры.
          <br />
          <br />
          2.2.5. Администрация имеет право планово либо внепланово изменять
          технические характеристики и параметры программно-технических средств,
          задействованных на Сайте, в том числе с временным приостановлением
          работы Сайта.
          <br />
          <br />
          2.2.6. Администрация оставляет за собой право хранить (архивировать)
          любые сообщения Пользователя на Сайте, созданные им темы, подписи с
          целью сохранения (обеспечения) доказательств по любому гражданскому,
          уголовному, административному делу.
          <br />
          <br />
          2.2.7. Администрация вправе удалять и изменять сообщения и (или)
          материалы Пользователя без объяснения причин.
          <br />
          <br />
          2.2.8. Администрация обязана оказывать Услуги Пользователю в
          соответствии с настоящим Пользовательским соглашением.
          <br />
          <br />
          2.2.9. Администрация обязана принимать меры по защите от утраты, а
          также разглашения без согласия Пользователя сведений, указанных в п.
          1.5 настоящего Пользовательского соглашения (исключение составляют
          ситуации, описанные в пункте 5.5 данного Пользовательского
          соглашения).
          <br />
          <br />
          2.3. Права и обязанности Модератора:
          <br />
          <br />
          2.3.1. Модератор имеет право без предварительного уведомления удалять
          и изменять любую информацию, размещенную Пользователем на Сайте.
          <br />
          <br />
          2.3.2. Модератор имеет право в случае возникновения вопросов/спорных
          ситуаций запросить у Пользователя необходимую для решения вопроса
          дополнительную информацию.
          <br />
          <br />
          В случае расторжения Пользовательского соглашения Пользователь теряет
          возможность оставлять и размещать сообщения на Сайте.
          <br />
          <br />
          Администрация Сайта обеспечивает хранение данных Пользователя в
          течение одного года с даты обезличивания профиля (пункт 4
          Постановления Совета Министров Республики Беларусь 23.11.2018 №850). В
          указанный период Пользователь вправе восстановить свой профиль путем
          обращения к Администрации Сайта посредством отправки запроса в
          поддержку пользователей или отправки электронного письма на почту
          oldmouseminsk@gmail.com с указанного при регистрации электронного
          ящика. В течение года с момента расторжения Пользовательского
          соглашения Пользователь не имеет права регистрировать новый профиль с
          использованием номера мобильного телефона и адреса электронной почты,
          которые использовались им ранее при регистрации обезличенной учетной
          записи (профиля).
          <br />
          <br />
          Пользователь имеет право обжаловать в судебном порядке решение о
          расторжении в одностороннем порядке Пользовательского соглашения
          Администрацией Сайта в месячный срок со дня получения такого
          уведомления.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            3. Требования при использовании Сайта:
          </span>
          3.1. Ник пользователя:
          <br />
          3.1.1. Ник пользователя должен состоять более чем из двух символов и
          не должен превышать 15 символов.
          <br />
          3.1.2. Запрещается использовать в Нике (так же как и в служебных полях
          — город, оборудование и др.) адреса веб-сайтов, доменные имена, а
          также грубые, оскорбительные и нецензурные выражения.
          <br />
          3.1.3. Запрещается выбор Пользователем Ника, идентичного или сходного
          до степени смешения с ником другого зарегистрированного пользователя,
          и размещение сообщений от имени этого пользователя.
          <br />
          3.1.4. Запрещается использовать в Нике рекламу, в том числе рекламные
          ссылки и скрытую рекламу, товарные знаки, иные средства
          индивидуализации участников гражданского оборота, товаров, работ и
          услуг.
          <br />
          3.1.5. Ник пользователя не должен нарушать требования законодательства
          Республики Беларусь.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">4. Модерация:</span>
          4.1. За соблюдением настоящего Пользовательского соглашения следят
          Модераторы и Администрация. Модераторы и Администрация могут делать
          Пользователям предупреждения, редактировать, удалять сообщения
          Пользователей, закрывать и удалять темы, применять меры взыскания к
          Пользователям.
          <br />
          <br />
          4.2. Пользователь, систематически нарушающий Пользовательское
          соглашение, может быть лишен доступа к Сайту. При попытках повторной
          регистрации нарушитель блокируется без предупреждения.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            5. Ответственность. Ограничение ответственности:
          </span>
          5.1. Все комментарии отражают мнения их авторов, пользователи несут
          всю ответственность за распространяемую в своих комментариях
          информацию.
          <br />
          <br />
          5.2. Администрация не обладает соответствующими знаниями и ресурсами
          (в том числе и людскими), чтобы отследить все комментарии и проверить
          их на соответствие законодательству. Поэтому Администрация не несет
          никакой ответственности за достоверность и законность комментариев,
          публикуемых пользователями на Сайте.
          <br />
          <br />
          5.3. Администрация стремится содействовать соблюдению законодательства
          при размещении Пользователями информации на Сайте, однако не подменяет
          собой государственные органы, которые призваны не допускать нарушения
          законодательства и прав и законных интересов граждан и организации.
          <br />
          <br />
          5.4. В соответствии с законодательством правоохранительные, налоговые
          и судебные органы Республики Беларусь в пределах своей компетенции
          имеют право мотивированно обратиться к Администрации за информацией о
          любом из Пользователей, разместивших информацию на Сайте, и
          Администрация обязана предоставить им всю доступную информацию.
          <br />
          <br />
          5.5. Пользователи, размещающие информацию, должны быть готовы в случае
          необходимости самостоятельно предоставить доказательства ее
          правомерности и законности.
          <br />
          <br />
          5.6. Администрация оставляет за собой право привлекать Пользователей в
          качестве свидетелей, третьих лиц, соответчиков в суде и
          правоохранительных органах.
          <br />
          <br />
          5.7. Сайт функционирует на условиях «как есть» (as is), и
          Администрация не дает гарантии в отношении его качества, возможности
          его использовать в любое время по собственному выбору. Администрация
          также не гарантирует достоверность информации на Сайте, безопасность
          Сайта (в том числе отсутствие вирусов), непрерывность и отсутствие
          сбоев, ошибок или внешнего вмешательства при функционировании Сайта.
          Администрация не гарантирует работоспособность Сайта в любое время.
          <br />
          <br />
          5.8. Сообщения посетителей на Сайте в силу действий посетителей Сайта
          могут иметь непристойный характер, быть оскорбительными, вводящими в
          заблуждение, ошибочными, недостоверными, и Администрация не несет
          ответственности за возможный ущерб, причиненный такими сообщениями.
          Администрация не несет ответственности за любую информацию на Сайте,
          которая появляется в результате работы с Сайтом Пользователей, не
          контролирует появление такой информации и не несет ответственности за
          любой возможный ущерб, который может быть причинен такой информацией.
          Администрация не гарантирует, что информация, размещенная
          Пользователями на Сайте, полна, полезна и правдива, и не несет
          ответственности за такую информацию. В силу значительных потоков
          информации, которые создаются в результате функционирования Сайта,
          Администрация не имеет возможности просматривать всю информацию,
          которую пользователь Сайта намеревается разместить.
          <br />
          <br />
          5.9. Администрация не гарантирует, что Сайт будет совместим и/или
          функционировать с любым программным обеспечением вашего компьютера. В
          сообщениях Пользователей на Сайте могут стоять ссылки на другие сайты
          или ресурсы. Поскольку Администрация не контролирует другие сайты или
          ресурсы, Администрация не несет ответственности за работоспособность
          таких сайтов или ресурсов, а равно за содержание, рекламу, материалы,
          товары и услуги, доступные на таких сайтах или ресурсах. Администрация
          не несет ответственности за любой вред, который может быть причинен
          вам третьими лицами, разместившими такие ссылки.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">6. Авторские права:</span>
          6.1. Размещая свое сообщение, Пользователь подтверждает наличие у него
          всех необходимых прав на размещение данного сообщения.
          <br /> <br />
          6.2. Размещая свое сообщение на Сайте, Пользователь безвозмездно
          передает Администрации права на его использование в любой форме и
          любым способом, включая, но не ограничиваясь: воспроизведение,
          распространение, показ, исполнение, перевод, переделка (переработка),
          передача в эфир, по кабелю, проводам или с помощью иных аналогичных
          средств.
          <br /> <br />
          6.3. Третьим лицам при использовании (цитировании) информации с Сайта
          необходимо получить согласие у Пользователей, разместивших данную
          информацию, либо у Администрации и в обязательном порядке дать ссылку
          на Сайт.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            7. Порядок изменения данного Пользовательского соглашения:
          </span>
          7.1. Пользовательское соглашение (в том числе любая из его частей)
          может быть изменено Администрацией в любой момент без необходимости
          получения согласия Пользователя. Новая редакция Пользовательского
          соглашения вступает в силу с момента ее размещения на Сайте, если иное
          не предусмотрено новой редакцией Соглашения.
          <br /> <br />
          7.2. В случае несогласия Пользователя с внесенными изменениями и/или
          дополнениями Пользователь должен отказаться от дальнейшего
          использования Сайта. Если Пользователь пользуется Сайтом после даты
          внесения изменений в настоящее Пользовательское соглашение,
          Администрация будет расценивать данный факт как согласие с измененным
          Пользовательским соглашением. данных.
        </div>
        {/* </div> */}
      </PageWrapper>
      <RecomendedQuests {...props} />
    </>
  );
};

export default memo(TermsOfUseContainer);
